import { render } from "./VcgProviders.vue?vue&type=template&id=6bead42d&scoped=true"
import script from "./VcgProviders.vue?vue&type=script&lang=js"
export * from "./VcgProviders.vue?vue&type=script&lang=js"

import "./VcgProviders.vue?vue&type=style&index=0&id=6bead42d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bead42d"]])

export default __exports__